export default __webpack_public_path__ + "static/media/visit.d4b4ff68.svg";